export const ALERT_TYPES = {
    INFO: "INFO",
    ERROR: "ERROR",
} as const;

export enum PAGE_ROUTES {
    ABOUT_ME = "about-me",
    EDUCATION = "education",
    EXPERIENCE = "experience",
    PREFERENCE = "preferences",
}

export const SECTION_SUBSTEPS_MAP: Record<PAGE_ROUTES, Record<string, number>> = {
    [PAGE_ROUTES.ABOUT_ME]: {
        "1": 1,
        "2": 2,
    },
    [PAGE_ROUTES.EDUCATION]: {
        "": 1,
    },
    [PAGE_ROUTES.EXPERIENCE]: {
        "": 1,
        "1": 2,
        confirmation: 3,
        "2": 4,
    },
    [PAGE_ROUTES.PREFERENCE]: {
        "": 1,
        "1": 2,
        "2": 3,
        "3": 4,
        "4": 5,
        telecaller: 6,
        delivery: 6,
    },
};

export const WORK_PREFERENCE_QUESTIONS_TYPE = {
    TEXT: "TEXT",
    MULTI_SELECT: "MULTI_SELECT",
    SINGLE_SELECT: "SINGLE_SELECT",
};

export const APP_INTERACTION_TYPES = {
    CALENDAR: "CALENDAR",
    PROFILE_IMAGE: "PROFILE_IMAGE",
    LOCATION: "LOCATION",
    ACCESS_TOKEN: "ACCESS_TOKEN",
    AUDIO_UPLOAD: "AUDIO_UPLOAD",
};

export const CITIES_STATUS = {
    LIVE: 0,
    NON_LIVE: 1,
} as const;

export const ONBOARDING_SOURCE = {
    ONBOARDING: "Onboarding",
    RR: "R+R Enrichment",
    REVISED_RR: "Revised_R+R",
} as const;

export const EXPERIENCE_LEVEL = {
    FRESHER: "Fresher",
    EXPERIENCED: "Experienced",
};

export const ONBOARDING_SCREEN = {
    FIRST_ONBOARDING: "First onboarding",
    LAST_ONBOARDING: "Last onboarding",
};

export const ONBOARDING_OPTION = {
    RESUME_PARSED: "Resume parsed",
    MANUAL: "Manual",
};

export const UPLOAD_FILE_ERROR_TYPE = {
    FILE_TYPE: "file_type",
    SIZE_ISSUE: "size_issue",
};

export const IS_R2R_USER_SESSION_KEY = "__isR2Ruser__";
export const R2R_LOCATION_FILLED_SK = "R2R_LOCATION_FILLED";
export const R2R_SKILLS_FILLED_SK = "R2R_SKILLS_FILLED";
export const R2R_ENG_LEVEL_FILLED_SK = "R2R_ENG_LEVEL_FILLED";
export const R2R_EXP_YEARS_FILLED_SK = "R2R_EXP_YEARS_FILLED";
export const R2R_CURR_SALARY_JOB_TYPE_NOTICE_PERIOD_FILLED_SSK =
    "R2R_CURR_SALARY_JOB_TYPE_NOTICE_PERIOD_FILLED";
export const R2R_EXP_UPDATED_SSK = "R2R_EXP_UPDATED";
export const R2R_KEY_RESUME_SUBMIT = "RESUME_SUBMIT";
export const KEY_USER_ID = "user_id";
export const KEY_IS_EXPERIENCED = "is_experienced";

export const CITIES_STATUS_FOR_MIXPANEL_PROPERTY = {
    LIVE: 1,
    NON_LIVE: 0,
} as const;

export const KEY_RETURN_TO_POST_ONBOARDING = "return_to_post_onboarding";

// Query Params:
export const WEB_QUERY_PARAMS = {
    WEB_INVOCATION_TYPE: "web_invocation_type",
    REVISED_RNR_SOURCE: "revised_rnr_source",
};

export const WEB_QUERY_PARAM_VALUES = {
    NB_REVISED_RNR: "NBRevisedRnR",
    COMMUNITY_ONBOARDING: "CommunityOnBoarding",
    TIGER_EYE_REVISED_RNR: "TigerEyeRevisedRnR",
};

export const UNLEASH_KEYS = {
    IS_ENABLE_RESUME_PARSING: "is_enable_resume_parsing",
};
export const IS_COMMUNITY_ONBOARDING_SESSION_KEY = "__isCommunityOnboarding__";
